<template>
  <div>
    <v-container grid-list-xs class="pa-0 ma-0" fluid>
      <v-tabs v-model="nTabSelect" show-arrows active-class="active-item" background-color="background_tab" height="45" color="color_tab" class="d-flex justify-start my-1 align-items-center">
        <v-tab v-for="(itemTab , i) in aDataTab?.aSecciones" :key="`item-tab-${i}`" class="text-tab">
          {{itemTab.seccion}}
          <v-menu offset-y >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon >
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item class="item-submenu-editar">
                <v-btn color="secondary" text block small class="sub-btn-editar justify-start"  @click="onEditarSeccion(itemTab)"><v-icon left>mdi-pencil-outline</v-icon>
                  {{ $store.state.jsIdioma.oEquivalencias.btnEditar }}
                </v-btn>
              </v-list-item>
              <v-list-item class="item-submenu-editar" v-if="aDataTab?.aSecciones.length > 1"  >
                <v-btn color="secondary" text block small class="sub-btn-editar justify-start" @click="onEliminarSeccion(itemTab)" ><v-icon left>mdi-delete</v-icon>
                  {{ $store.state.jsIdioma.oEquivalencias.btnEliminar }}
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-tab>
        
        <v-btn class="mt-4 ml-3" x-small text elevation="0" icon color="primary" @click="bShowFormSeccion = true">
          <v-icon>mdi-plus-circle</v-icon>
        </v-btn>
        <v-btn color="#FFFFFF" icon v-if="aDataTab?.aSecciones?.length <= 6 " @click="onAgregarSeccion"><v-icon>mdi-plus-box</v-icon></v-btn>
      </v-tabs>
      <v-tabs-items v-model="nTabSelect">
        <v-tab-item v-for="(item, key) in aDataTab?.aSecciones" :key="key">
          <div class="cont-embed">
            <div v-if="item.tipoReporte=='0'">
              <v-row v-if="bMostrarGraficosBi">
                <v-col cols="12" class="d-flex">
                  <PowerBIReportEmbed
                    :embedConfig = oConfig
                    :cssClassName = "'reportClass'"
                    :phasedEmbedding="false"
                    style="width: 100%; height: 100vh;"
                    >
                    </PowerBIReportEmbed>
                </v-col>
              </v-row>
            </div>
            <v-container v-else-if="!item.URL"> 
              <v-row justify="center">
                <v-col cols="12" md="8" class="text-center">
                  <img src="@/assets/img/back-secciones-vacio.png" width="55%">
                  <p v-if="getAPermisos.priv_insert === '1'">{{ $store.state.jsIdioma.oEquivalencias.msgSinUrl }}</p>
                  <v-btn v-if="getAPermisos.priv_insert === '1'" color="primary" outlined @click="onEditarSeccion(item)">
                    {{ $store.state.jsIdioma.oEquivalencias.cmpIndicadorAgregarUrl }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <embed  v-else
              :src="item.URL" 
              type=""
              width="100%"
              height="100%"
            />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  <!-- FORMULARIO CREAR SECCION -->
  <FormSeccion
    v-if="bShowFormSeccion"
    :key="keyForm"
    :sTableName="sTabla"
    :sIdTable="sIdTable"
    :titulo="$store.state.jsIdioma.oEquivalencias.cmpSeccion"
    :bNuevo = "bNuevo"
    :idItem = "sIdTable"
    :bMostrarFormulario = "bShowFormSeccion"
    :oDataFormularioAdicional="{ Tipo:2, Menu_Padre:`${aDataTab.idIndicador}`}"
    :bDataFormularioAdicionalObligatorio="true"
    :oData="oItem"
    @onCancelar="onCancelar"
    @onRegistroExitoso="onRegistroExitoso"
  />

  <modal-mensaje-general
    v-model="oModalMensajeInput.bModalMensaje"
    :sMensaje="oModalMensajeInput.sMensaje"
    :nTipo="oModalMensajeInput.nTipo"
    :sNombreBotonConfirmar="oModalMensajeInput.sNombreBotonConfirmar"
    @respuesta="onRespuestaModal"
  />

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import FormSeccion from '@/views/Indicadores/FormIndicador.vue'
import axiosServices from "@/services/axiosServices.js"
import { PowerBIReportEmbed } from 'powerbi-client-vue-js';

export default {
  props:{
    aDataTab:{}
  },
  components:{
    FormSeccion,
    PowerBIReportEmbed
  },
  data() {
    return {
      sTabla:"Menu_Indicadores$1",
      sIdTable:"idMenu_Indicadores",
      nTabSelect:0,
      bShowFormSeccion:false,
      keyForm:0,
      bNuevo:true,
      oItem:{},
      oInfoTab:{},
      oModalMensajeInput: {
        bModalMensaje: false,
        sMensaje: "",
        nTipo: 1,
        sNombreBotonConfirmar: 'Eliminar'
      },
      oConfig:{
        type: "report",
        id: "",
        embedUrl: "https://app.powerbi.com/reportEmbed?reportId=f475b7da-3c38-4925-9b0e-48ad0bbb08b3&$filter=DIM_CLIENTES%2FCOD_ORIGEN=055",
        accessToken: "",
        tokenType: 1,
        settings: {
            panes: {
                filters: {
                    expanded: false,
                    visible: false
                }
            },
        }
      },
      bMostrarGraficosBi:false
    }
  },
  mounted() {
    this.onValidacionPowerBI();
  },
  methods: {
    async onCargarConfigPowerBi(nIdReportePowerBi){
      this.bMostrarGraficosBi=false;
      const { aData } =  await axiosServices.getConfiguration("/indicadores/obtenerDatosReportePowerBi", true, `nIdReportePowerBi=${nIdReportePowerBi}`)
      if(aData?.sToken){
        this.oConfig.accessToken = aData.sToken;  
        this.oConfig.id = aData.sIdReporte;
        this.oConfig.embedUrl = `https://app.powerbi.com/reportEmbed?reportId=${aData.sIdReporte}${aData.sFiltro}`;
        this.bMostrarGraficosBi=true;
      }
    },
    onAgregarSeccion(){
      this.bShowFormSeccion=true
      this.keyForm+=1
      this.bNuevo = true
    },
    onRegistroExitoso(){
      this.bShowFormSeccion=false
      this.oItem = {}
      this.bNuevo = true
      this.$emit('onRegistroExitoso');
    },
    onCancelar(){
      this.bShowFormSeccion=false
      this.keyForm+=1
      this.oItem = {}
      this.bNuevo = true
    },
    onEditarSeccion(obSec){
      this.bShowFormSeccion=true
      this.keyForm+=1
      this.bNuevo = false
      this.oItem = {
        idMenu_Indicadores : obSec.idSeccion,
        Nombre_menu : obSec.seccion,
        Tipo: 2,
        Icono: obSec.icono,
        Menu_padre: obSec.idIndicador,
        URL: obSec.URL,
      }
    },
    onEliminarSeccion(oSeccion){
      this.oItem = oSeccion
      this.oModalMensajeInput.bModalMensaje = true
      this.oModalMensajeInput.sMensaje = this.$store.state.jsIdioma.oEquivalencias.msgConfirmarEliminarSeccion
    },
    onRespuestaModal(bRespuesta) {
      this.oModalMensajeInput.bModalMensaje = false
      if (bRespuesta) {
        this.onEliminarAccion(this.oItem)
      }
      this.oItem = {}
    },
    async onEliminarAccion(oSeccion){
      let oResponse = await axiosServices.postConfiguration(`/indicadores/seccion/eliminar`,{
        idMenu_Indicadores: oSeccion.idSeccion
      }, 
      true, 
      `sTable=${this.sTabla}`)
      
      if (oResponse.sStatus == 'success'){
          this.$swal({
            timer: 1500,
            icon:`${oResponse.sStatus}`,
            title:`${((oResponse.sValue) && oResponse.sValue.length>0)? oResponse.sValue : oResponse.sMessage}`,
            showConfirmButton: false
          })
        }
      this.$emit('onRegistroExitoso')
    },
    onNuevo(){
      this.$emit('onNuevo', true)
    },
    onValidacionPowerBI(){
      if(this.aDataTab?.aSecciones[this.nTabSelect].tipoReporte=="0"){
        this.onCargarConfigPowerBi(this.aDataTab?.aSecciones[this.nTabSelect].idDashPowerBi);
      }
    }
  },
  watch:{
    /*nTabSelect(){
      this.onValidacionPowerBI();
    }*/
  },
  computed:{
    ...mapGetters('indicadores',['getAPermisos' ]),
  }
}
</script>
<style lang="scss" scoped>

.cont-embed{
  width: 100%;
  height: calc(100vh - 130px);
}
.item-submenu-editar{
  min-height: 10px;
  max-height: 45px;
}
.sub-btn-editar{
  text-transform:none;
  letter-spacing:normal;
  max-height: 45px;
}

</style>